<template>
  <div>
    <v-card>

      <v-card-title>
        دیکته #
        {{ dictation?.id }}
        <br>
        {{ dictation?.title }}
        <br>
        تعداد سوالات :
        {{ dictation?.children?.length }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle>
        <v-row>
          <v-col cols="2">
            هنرجو :
            {{ student?.name }}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn elevation="0" @click="goToFile(dictation.file)" style="letter-spacing: normal">
              <v-icon>mdi-paperclip</v-icon>
              فایل راهنما
            </v-btn>
          </v-col>
          <v-col cols="8" class="text-right">
            {{ dictation?.description }}
          </v-col>
        </v-row>

      </v-card-subtitle>
      <v-card-actions class="text-left">
        <v-row>
          <v-col class='text-left'>
            <v-icon class="back-link-icon" x-large
                    @click="$router.push('/classes/manage/item/show/'+classId+'/'+itemId+'/'+studentId)"
            >
              mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-text>
        <v-row class="mt-16 mr-16">
          <v-col cols="12" v-for="(child , index) in children" :key="index+'round'">
            <v-row class="justify-center">
              <v-col cols="12" class="text-center">
                <audio :src="child.file" controls></audio>
              </v-col>
              <v-col cols="12">
                <v-row style="direction: ltr!important;">
                  <v-col
                      class="text-center"
                      cols="9"
                  >
                    <v-row>
                      <v-col
                          cols="1"
                          v-for="(correctAnswer, correctAnswerIndex) in child.answers_array"
                          :key="index + 'option' + correctAnswerIndex"
                      >
                        <img :src="correctAnswer.cover" class="correct-answer-image"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="text-right">
                    پاسخ صحیح دیکته
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="2"></v-col>
                      <v-col cols="10">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                پاسخ های هنرجو
              </v-col>
              <v-col cols="8" class="text-center" style="text-align: right!important;">
                <v-row class="text-center" v-for="(answer , answerIndex) in child.student_answers" :key="answer.id+'st-answer'"
                       style="direction: ltr!important;">
                  <v-col cols="1" class="mt-12" style="position:absolute;left: 0!important;">
                    {{answer.created_at_fa}}
                  </v-col>
                  <v-col cols="1" v-for="answerInstance in answer.answers_array"
                         :key="answerInstance.id+'st-answer-ins'+answer.id+'-'+index+'-'+answerIndex+'-'">
                    <img :src="answerInstance.cover"
                         v-if="answer.correct_count === Array.isArray(child.answers_array) ? child.answers_array.length : Object.keys(child.answers_array).length && !answer.incorrect_count"
                         class="answer-image-correct">
                    <img :src="answerInstance.cover" v-else class="answer-image-incorrect">
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row style="direction: ltr!important;">

              <v-col cols="9">
                <v-row>
                  <v-col
                      cols="1"
                      v-for="(option, optionIndex) in child.options_array"
                      :key="index + 'option' + optionIndex"
                  >
                    <img :src="option.cover" class="option-image"/>
                    {{ option.id }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3" class="text-right">
                گزینه های دیکته
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </div>
</template>
<script>
export default {
  name: "OnlineClassDictationV2",
  data() {
    return {
      studentId: null,
      classId: null,
      itemId: null,
      dictationId: null,
      dictation: null,
      children: [],
      student: null
    }
  },
  mounted() {
    this.studentId = this.$route.params.studentId
    this.classId = this.$route.params.classId
    this.itemId = this.$route.params.itemId
    this.dictationId = this.$route.params.dictationId
    this.getDictation()
  },
  methods: {
    goToFile(url) {
      window.open(url, "_blank");
    },
    getColSize(child, optionIndex) {
      const totalOptions = child.options_array.length;
      // Custom logic for handling number of columns
      if (totalOptions === 5) {
        // 3 in first row, 2 in second row
        return optionIndex < 3 ? 4 : 6;
      } else if (totalOptions === 6) {
        // 3 in first row, 3 in second row
        return 4;
      } else if (totalOptions === 7) {
        // 4 in first row, 3 in second row
        return optionIndex < 4 ? 3 : 4;
      } else {
        // Default case, 4 per row
        return 3;
      }
    },
    getDictation() {
      window.axios.get(`course/dictation/student/details/${this.studentId}/${this.dictationId}`).then((res) => {
        this.children = res.data.data.data
        this.student = res.data.data.student
        this.dictation = res.data.data.item_dictation
      })
    }
  }
}
</script>
<style scoped>


.row{
  justify-content: center!important;
}

.option-image {
  border-radius: 10px;
  width: 100px;
  height: 100px;
  object-fit: fill;
  cursor: pointer;
  transition: transform 0.2s, filter 0.2s; /* Animation */
}

.correct-answer-image {
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: #535553 !important;
  width: 100px;
  height: 100px;
  object-fit: fill;
}


.option-image:hover {
  transform: scale(1.1); /* The image will scale up to 110% of its original size */
  filter: grayscale(80%);
}

.answer-image-correct {
  border-radius: 10px;
  border-color: green;
  border-style: solid;
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.answer-image-incorrect {
  border-radius: 10px;
  border-color: red;
  border-style: solid;
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>